import type { StripeSchoolAdminsResponse } from '@kimuno/api-sdk';
import immutable from 'object-path-immutable';

import { AsyncActionStatus } from '../actions/common.actionTypes';
import {
	GET_STRIPE_SCHOOL_ADMINS,
	type StripeSchoolAdminsActionTypes,
} from '../actions/stripeSchoolAdmins.actionTypes';
import type { StoreItem } from '.';

export interface StripeSchoolAdminsState {
	admins: StoreItem<StripeSchoolAdminsResponse>;
}

const initialState: StripeSchoolAdminsState = {
	admins: { status: AsyncActionStatus.INITIAL },
};

// biome-ignore lint/style/useDefaultParameterLast: parameter order is a fixed contract (Redux reducer signature)
const stripeSchoolAdmins = (state = initialState, action: StripeSchoolAdminsActionTypes) => {
	switch (action.type) {
		case GET_STRIPE_SCHOOL_ADMINS.START:
			return immutable(state).set(['admins', 'status'], AsyncActionStatus.LOADING).value();

		case GET_STRIPE_SCHOOL_ADMINS.SUCCESS:
			return immutable(state)
				.set(['admins', 'data'], action.result)
				.set(['admins', 'status'], AsyncActionStatus.READY)
				.set(['admins', 'error'], undefined)
				.value();

		case GET_STRIPE_SCHOOL_ADMINS.ERROR:
			return immutable(state)
				.set(['admins', 'error'], action.error.message)
				.set(['admins', 'status'], AsyncActionStatus.ERROR)
				.value();

		default:
			return state;
	}
};

export default stripeSchoolAdmins;
